import { Paperclip } from 'lucide-react';

import { formatShortDate, formatTime } from '@core/dates';
import { formatMoney } from '@core/money';

import type { Category, Expense } from '@/lib/types';

import { CategoryBadge } from './ui';

export function ExpenseItem({
  expense: e,
  category,
  hasReceipt,
  showDate,
  onOpen,
}: {
  expense: Expense;
  category?: Category;
  hasReceipt?: boolean;
  showDate?: boolean;
  onOpen: (id: string) => void;
}) {
  const meta = [e.title ? category?.name : null, e.merchant].filter(Boolean).join(' · ');
  const when = showDate ? formatShortDate(e.expenseDate) : e.expenseTime ? formatTime(e.expenseTime) : '';
  return (
    <button className="list-row" onClick={() => onOpen(e.id)}>
      <CategoryBadge icon={category?.icon ?? 'circle-ellipsis'} color={category?.color ?? 'slate'} />
      <div className="grow">
        <div className="ellipsis" style={{ fontWeight: 600 }}>
          {e.title || category?.name || 'Expense'}
        </div>
        <div className="muted ellipsis" style={{ fontSize: 13 }}>
          {[meta, when].filter(Boolean).join(' · ')}
        </div>
      </div>
      {hasReceipt && <Paperclip size={15} className="faint" aria-label="Has receipt" />}
      <strong className="num">{formatMoney(e.amountMinor, e.currency)}</strong>
    </button>
  );
}
